export default {
  baseUrl: 'https://sukien.ff.garena.vn',
  cdn: 'https://dl.dir.freefiremobile.com/common/Local/VN/Web_event/Web_14ngay_2207/',
  cdnToken: '/images/'
}



// WEBPACK FOOTER //
// ./src/config/common.js